import { Navigate, Outlet } from 'react-router-dom';
import { useUserContext } from '../lib/users-context';

const RequireAdmin = () => {
  const { isAdmin } = useUserContext();
  if (!isAdmin) {
    return <Navigate to='/' replace />;
  }
  return <Outlet />;
};

export default RequireAdmin;
